import React from 'react'

const modeTick = () => {
  return (
    <>
        <svg width="24" height="24" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1_2)">
            <path d="M13.8593 6.57393C14.1339 6.84859 14.1339 7.29381 13.8593 7.56833L9.1423 12.2854C8.86765 12.56 8.42256 12.56 8.1479 12.2854L5.90244 10.0398C5.62778 9.76532 5.62778 9.3201 5.90244 9.04558C6.17696 8.77092 6.62218 8.77092 6.8967 9.04558L8.64503 10.7939L12.8649 6.57393C13.1395 6.29941 13.5848 6.29941 13.8593 6.57393ZM18.8809 9.42969C18.8809 14.4044 14.8549 18.4297 9.88086 18.4297C4.90611 18.4297 0.880859 14.4037 0.880859 9.42969C0.880859 4.45494 4.9068 0.429688 9.88086 0.429688C14.8556 0.429688 18.8809 4.45563 18.8809 9.42969ZM17.4746 9.42969C17.4746 5.23222 14.0778 1.83594 9.88086 1.83594C5.6834 1.83594 2.28711 5.23277 2.28711 9.42969C2.28711 13.6272 5.68394 17.0234 9.88086 17.0234C14.0783 17.0234 17.4746 13.6266 17.4746 9.42969Z" fill="#ED5C2F"/>
            </g>
            <defs>
            <clipPath id="clip0_1_2">
            <rect width="18.7849" height="18" fill="white" transform="translate(0.880859 0.429688)"/>
            </clipPath>
            </defs>
        </svg>
    </>
  )
}

export default modeTick;